<template>
  <div class="landing">
    <h1 class="landing__title">
      <img src="@/assets/img/pdlb-logo-white.jpg" class="img-fluid" alt="Les Pirates de la Bouffe">
      <span class="sr-only">Les Pirates de la Bouffe</span>
    </h1>
    <p v-if="type === 'generic'">La commande {{name}} n'est pas encore disponible à cette heure...</p>
    <p v-if="type === 'too-soon'">La commande {{name}} sera disponible à partir de <strong>{{startDate}}</strong></p>
    <p v-if="type === 'too-late'">La commande {{name}} n'est plus disponible... <span v-if="nextStartDate">Prochaine commande ouverte le <strong>{{nextStartDate}}</strong></span></p>
  </div>
</template>

<script>
  import {dateToStr, tooSoonOrTooLate} from "@/store/helper/dateCheck";

  export default {
    name: 'NoAccess',
    data() {
      return {
        name: this.$route.params.id,
        type: 'generic'
      }
    },
    computed: {
      accessibleRules() {
        return this.$store.getters.spreadsheetAccessibleRules(this.name);
      },
      startDate() {
        if (this.accessibleRules) {
          return dateToStr(this.accessibleRules.from);
        }
        return '';
      },
      nextStartDate () {
        const nextOrderDate = this.$store.getters.spreadsheetNextOrderDate(this.name);
        console.log(nextOrderDate, typeof (nextOrderDate), nextOrderDate === '');
        if (nextOrderDate === '') {
          return false;
        }

        return dateToStr(nextOrderDate);
      },
      endDate() {
        if (this.accessibleRules) {
          return dateToStr(this.accessibleRules.to);
        }
        return '';
      }
    },
    mounted() {
      if (this.accessibleRules) {
        this.type = tooSoonOrTooLate(this.accessibleRules.from);
      }

      this.$store.dispatch('setPageTitle');
    }
  }
</script>

<style lang="scss">
  .landing {
    max-width: 380px;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
  }
</style>

